import { Component } from '@angular/core';
export class NotfoundComponent {
constructor() { }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'app-notfound',
  template: `
    <div id="content" style="text-align:center;">
      <h2>404 - Página não encontrada</h2>
      <p>A página que você está procurando não foi encontrada.</p>
    </div>
  `,
  styles: [`

  `]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function NotfoundComponent_tsickle_Closure_declarations() {
/** @type {?} */
NotfoundComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
NotfoundComponent.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
